import React from "react"
import Icon from "../Icon/Icon"
import {IcomoonIconName} from "../Icon/icons"
import Skeleton from "react-loading-skeleton"
import {InterestFormulaBox} from "../InterestFormulaBox/InterestFormulaBox"
import {useAccessToken} from "../../services/auth"
import {useAsyncResult} from "../../hooks/useAsyncResult"
import {getPrimeLoanRate} from "../../resources/primeLoanRate"
import {AsyncResultComponent} from "../../containers/AsyncResult/AsyncResult"
import {formatPercent} from "../../utilities/numbers"
import moment from "moment"

const RATE_FORMAT = "111.[11]%"

export interface InterestRateItemProps {
	icon?: IcomoonIconName
	title?: string
	value?: string | number
	additionalInfo?: string
}

export interface InterestFormulaItemProps {
	icon?: IcomoonIconName
	title?: string
	interestFormula: string
	fedLowerBound: number
	fedUpperBound: number
}
export const InterestItem = ({icon, title, value, additionalInfo}: InterestRateItemProps) => (
	<div className="interest-rate-item">
		<div className="interest-rate-item-title-container">
			{icon && <Icon icon={icon} size={20} />}
			{title ? <span> {title} </span> : <Skeleton />}
		</div>
		<div className="interest-rate-item-value-container">{value ? <span>{value}</span> : <Skeleton />}</div>
		<div className="interest-rate-item-additional-info-container">
			{additionalInfo ? <span>{additionalInfo}</span> : <Skeleton />}
		</div>
	</div>
)

export const InterestFormulaItem = ({
	title,
	interestFormula,
	fedLowerBound,
	fedUpperBound,
}: InterestFormulaItemProps) => (
	<div className="interest-formula-item">
		<div className="interest-rate-item-title-container">{title ? <span> {title} </span> : <Skeleton />}</div>
		<InterestFormulaBox interestFormula={interestFormula} fedLowerBound={fedLowerBound} fedUpperBound={fedUpperBound} />
	</div>
)

const PrimeLoanRatePending = () => <InterestItem icon={"Analytic Percentage"} />

export function PrimeLoanRateItem() {
	const accessToken = useAccessToken()
	const primeLoanRateResult = useAsyncResult(() => getPrimeLoanRate(accessToken))

	return (
		<AsyncResultComponent asyncResult={primeLoanRateResult} pendingComponent={<PrimeLoanRatePending />}>
			{({value: primeLoanRate}) => {
				const {
					data: {
						attributes: {rate, effectiveDate},
					},
				} = primeLoanRate
				const rateAsPercent = rate / 100
				// Handle both YYMMDD (legacy) and YYYY-MM-DD formats
				const formattedDate = moment(effectiveDate, "YYYY-MM-DD", true).isValid()
					? effectiveDate
					: moment(effectiveDate, "YYMMDD").format("YYYY-MM-DD")
				const additionalInfoString = `Effective from ${formattedDate}`
				return (
					<InterestItem
						icon={"Analytic Percentage"}
						title={"Prime Loan Rate"}
						value={formatPercent(rateAsPercent, RATE_FORMAT)}
						additionalInfo={additionalInfoString}
					/>
				)
			}}
		</AsyncResultComponent>
	)
}
